<template>
  <div style="padding-bottom:50px">
    <van-list
      v-model="loading"
      :finished="finished"
      :finished-text="liveList.length == 0 ? '' : '暂无更多直播'"
      @load="getBookLive"
      
    >
      <van-row v-if="liveList.length != 0 && getTokenType()">
        <van-col
          :span="24"
          class="bg-white live m-t-075"
          v-for="(item, index) in liveList"
          :key="index"
        >
          <van-row>
            <van-col :span="6">
              <van-image
                class="f-l-l"
                width="3.75rem"
                height="5rem"
                :src="item.teacherurl"
              />
            </van-col>
            <van-col :span="18" style="padding-left:0.5rem">
              <p class="f-s-6" style="color:#657081">
                <van-icon :name="triangleNew" />
                直播时间：{{ item.livestartDate }}-{{ item.liveendDate }}
              </p>
              <div
                class="f-s-16 m-t-3"
                style="color:#292E35;max-height:2.4rem;min-height:2.4rem;line-height:1.2rem"
              >
              <van-tag
              class="f-s-5 title-tag m-l-02 xz-button-grey f-l-l m-r-02 m-t-02"
              v-if="item.itname != null && item.itname != ''"
              >{{ item.itname }}</van-tag
            >
            <p class="overFlowTwo">
                {{ item.subject }}</p>
              </div>
              <p class="m-t-3 xz_LiveItem_Footer">
                <van-icon :name="people" size="0.6rem" />
                <span class="baseNum">{{item.teachers}}</span>
              </p>
            </van-col>
          </van-row>
        </van-col>
      </van-row>
    <NoData v-else text="您还没有预约直播,快去看看直播列表吧" path="/liveList" :empty="empty" />

    </van-list>
  </div>
</template>

<script>
export default {
  props: {
    liveList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      triangleNew: require("@/assets/imgs/triangleNew.png"),
      teacher: require("@/assets/imgs/teachcer.png"),
      loading: false,
      finished: false,
      people: require("@/assets/imgs/people.png"),
      empty:require("@/assets/imgs/empty/noLive.png")

    };
  },
  methods: {
    getBookLive() {
      this.$emit("getBookLive");
    },
  },
};
</script>

<style lang="less" scoped>
.live {
  padding: 0.5rem 0.5rem 0.5rem 0.5rem;
}
.baseNum {
  font-size: 0.65rem;
  margin-left: 0.2rem;
}
.xz_LiveItem_Footer {
  color: #73787f;
  line-height: 1rem;
}
</style>
